import Swiper from 'swiper';

const moduleName = 'intro';

export function intro() {

    Array.from(document.querySelectorAll('.js-intro')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const holder = self;
        const introSlider = holder.querySelector('.js-intro-slider');
        const introPagination = holder.querySelector('.js-intro-pagination');

        const introSwiper = new Swiper(introSlider, {
            effect: 'fade',
            speed: 500,
            // loop: true,
            simulateTouch: false,
            slideActiveClass: '_active',
            autoplay: {
                delay: 5000
            },
            pagination: {
                el: introPagination,
                clickable: true,
                bulletClass: 'intro__bullet',
                bulletActiveClass: '_active'
            }
        });

        /*$(document).on('touchstart click', '.header__dropdown-envelope.city-slide-animation', function(event){
            if (!$(this).find('.header__dropdown').hasClass('with-hint')){
                $('html').addClass('hint-open');
            }
        });*/

        $('.header__dropdown-envelope.city-slide-animation').hover(function(){
            introSwiper.autoplay.stop();
        },function(){
            introSwiper.autoplay.start();
        });
        /*introSwiper.on('slideChange', function () {
            $('html').removeClass('hint-open')
        });*/
    });

}